/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SubmitPostResponse, SubmitPostVars } from '../openapi-types.gen.js';

export type { SubmitPostResponse, SubmitPostVars } from '../openapi-types.gen.js';

export const useSubmitPost = createMutationHook<SubmitPostVars, SubmitPostResponse, unknown>({
  specName: 'useSubmitPost',
  path: '/v1/rewards/content/post',
  method: 'POST',
  resolveUrl: (vars: SubmitPostVars) => `/v1/rewards/content/post`,
  buildBody: (vars: SubmitPostVars) => ({ tweetUrlOrId: vars.tweetUrlOrId }),
  parseResponse: (raw: unknown): SubmitPostResponse => raw as SubmitPostResponse,
  
  
  
});
